import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  ContainerType,
  ContainerTypeQueryKeys,
  fetchContainerTypes,
} from 'services/clients/containerType';
import { ShippingLine } from 'types/Shipping';
import { useFilterSearchParams } from 'pages/Shipments/Containers/utilities';
import { ComboboxMultiselect } from 'components/tailwind-ui/ComboboxMultiselect';
import { fetchShippingLines } from 'services/clients/shippingLine';
import { Section } from './Section';

export const ContainerFilter: React.FC = () => {
  const { searchParams, setSearchParams } = useFilterSearchParams(true);

  const shippingLineQuery = useQuery({
    queryKey: ['shippingLines'],
    queryFn: ({ signal }) => fetchShippingLines({ signal }),
  });

  const handleShippingLineChange = (values: ShippingLine[]) => {
    setSearchParams({
      shippingLine: values.map((ssl) => ssl.key),
    });
  };

  const defaultShippingValue = (shippingLineQuery.data || []).filter((ssl) =>
    searchParams.shippingLine.includes(ssl.key)
  );

  const containerTypeQuery = useQuery([ContainerTypeQueryKeys.ContainerTypes], ({ signal }) =>
    fetchContainerTypes({ signal })
  );

  const handleContainerTypeChange = (values: ContainerType[]) => {
    setSearchParams({
      containerType: values.map((ct) => ct.key),
    });
  };

  const defaultContainerValue = (containerTypeQuery.data || []).filter((ct) =>
    searchParams.containerType.includes(ct.key)
  );

  return (
    <Section title="Container filters">
      <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
        <div>
          {!shippingLineQuery.isLoading && (
            <ComboboxMultiselect
              label="Shipping line"
              placeholder="Shipping line"
              options={shippingLineQuery.data || []}
              displayKey="name"
              defaultValue={defaultShippingValue}
              uniqueKey="key"
              onChange={handleShippingLineChange}
            />
          )}
        </div>
        <div>
          {!containerTypeQuery.isLoading && (
            <ComboboxMultiselect
              label="Container type"
              placeholder="Container type"
              options={containerTypeQuery.data || []}
              displayKey="name"
              defaultValue={defaultContainerValue}
              uniqueKey="key"
              onChange={handleContainerTypeChange}
            />
          )}
        </div>
      </div>
    </Section>
  );
};
ContainerFilter.displayName = 'Filters.More.Container';
